var _path, _path2, _path3, _path4, _path5, _path6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSignetLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 137 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m115.19 37.793c0.633-0.4951 1.22-1.0463 1.753-1.647 0.907-1.0166 1.663-2.1572 2.245-3.3871h-2.426c-0.556 0.9539-1.254 1.8191-2.069 2.5665-0.958 0.8304-2.035 1.513-3.197 2.0253-1.508 0.6455-3.139 0.9572-4.78 0.9137-1.403 0.0069-2.793-0.26-4.092-0.7857-1.261-0.4935-2.423-1.2091-3.4304-2.1125-0.9804-0.9261-1.774-2.0303-2.3378-3.2533-0.6098-1.3086-0.9762-2.7165-1.0812-4.1553l-0.0584-0.7915h24.442v-0.6169c0.013-1.8433-0.341-3.6709-1.04-5.3774-0.653-1.6022-1.611-3.0629-2.823-4.3008-1.212-1.2158-2.654-2.1793-4.243-2.8342-3.421-1.3812-7.247-1.3812-10.667 0-1.5943 0.6588-3.0393 1.6306-4.2486 2.8575-1.2124 1.262-2.1706 2.7436-2.8229 4.3648-1.3917 3.5556-1.3917 7.5019 0 11.058 0.6537 1.6187 1.6119 3.0982 2.8229 4.359 1.2073 1.2292 2.6529 2.2014 4.2486 2.8575 1.699 0.6979 3.522 1.0501 5.36 1.0359 1.152 0.0118 2.302-0.1133 3.425-0.3724 0.965-0.2223 1.902-0.5522 2.793-0.9836 0.799-0.3877 1.556-0.8578 2.256-1.4025l-0.029-0.0175zm-19.374-13.473c0.202-1.2229 0.609-2.4033 1.204-3.4919 0.5941-1.1041 1.3865-2.0903 2.3378-2.9099 0.9767-0.8194 2.0847-1.4687 3.2787-1.9205 2.618-0.9699 5.5-0.9699 8.118 0 1.189 0.4499 2.29 1.1017 3.255 1.9264 0.932 0.8221 1.703 1.8087 2.274 2.9098 0.58 1.1022 0.958 2.2984 1.116 3.5326l0.111 0.8322h-21.823l0.1286-0.8787z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m80.332 15.381c0.9319-0.0015 1.8535 0.195 2.7031 0.5763 0.8496 0.3814 1.6077 0.9389 2.2238 1.6352 1.4553 1.5597 2.1917 3.876 2.1917 6.8964v15.772h2.4839v-16.045c0.0292-1.6509-0.2177-3.2952-0.7306-4.8653-0.4323-1.2896-1.1244-2.4778-2.0339-3.4919-0.8563-0.9427-1.9123-1.6842-3.0917-2.1708-2.43-0.83-5.0685-0.83-7.4985 0-1.1787 0.4719-2.2369 1.1996-3.0976 2.1301-0.3326 0.3619-0.6337 0.7513-0.9001 1.1639l-0.6253 0.9661-0.6195-0.9661c-0.9638-1.4808-2.3526-2.6387-3.986-3.3231-2.43-0.83-5.0685-0.83-7.4985 0-1.1773 0.4819-2.2316 1.2196-3.0859 2.1592-0.9092 1.0152-1.603 2.2029-2.0397 3.4918-0.5079 1.5713-0.7527 3.215-0.7247 4.8653v16.086h2.4839v-15.772c0-3.0204 0.7364-5.3367 2.1917-6.8964 0.6169-0.6952 1.3753-1.2519 2.2247-1.6332s1.7705-0.5785 2.7022-0.5785 1.8528 0.1972 2.7022 0.5785 1.6077 0.938 2.2247 1.6332c1.4553 1.5597 2.1917 3.876 2.1917 6.8964v15.772h2.4839v-15.772c0-3.0204 0.7364-5.3367 2.1917-6.8964 0.6158-0.6966 1.3739-1.2543 2.2236-1.6357 0.8496-0.3814 1.7713-0.5777 2.7033-0.5758",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m132.45 13.042c-1.276 2e-4 -2.544 0.2106-3.752 0.6227-1.177 0.4802-2.231 1.2158-3.086 2.1533-0.909 1.0153-1.603 2.203-2.04 3.4919-0.507 1.5712-0.752 3.2149-0.724 4.8653v16.086h2.484v-15.772c0-3.0205 0.736-5.3368 2.191-6.8964 0.616-0.6967 1.374-1.2544 2.224-1.6357 0.85-0.3814 1.771-0.5777 2.703-0.5759h4.553v-2.3279l-4.553-0.0116z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m40-2.4414e-4h-13v40h13v-40z",
    fill: "url(#c)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m27-2.4414e-4h-14v40h14v-40z",
    fill: "url(#b)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m13-2.4414e-4h-13v40h13v-40z",
    fill: "url(#a)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 33.483,
    x2: 33.483,
    y1: 1.8058,
    y2: 38.604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0000C8",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0112CB",
    offset: 0.0324
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0545D2",
    offset: 0.1328
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0871D9",
    offset: 0.238
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A97DF",
    offset: 0.3462
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0CB6E4",
    offset: 0.4579
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0ECEE7",
    offset: 0.5744
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FDFEA",
    offset: 0.6976
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10E9EC",
    offset: 0.8323
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10ECEC",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 19.985,
    x2: 19.985,
    y1: 1.8058,
    y2: 38.604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0000C8",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10ECEC",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 6.4861,
    x2: 6.4861,
    y1: 1.8058,
    y2: 38.604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0000C8",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0003C8",
    offset: 0.1677
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010DCA",
    offset: 0.3024
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#021ECD",
    offset: 0.4256
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0436D0",
    offset: 0.5421
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0655D5",
    offset: 0.6538
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#087BDB",
    offset: 0.762
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0BA7E2",
    offset: 0.8672
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FDAE9",
    offset: 0.9676
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10ECEC",
    offset: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignetLogo);
export default __webpack_public_path__ + "static/media/signetLogo.b056cd109672813c2d2541d738073de5.svg";
export { ForwardRef as ReactComponent };